import { replaceMacros } from 'Misc/format';

export const getResource = (resource, format = 'text') => {
  resource = replaceMacros(resource, { CACHEBUSTER: new Date().getTime() }, '%%', '%%');
  resource = replaceMacros(resource, { timestamp: new Date().getTime() });

  return (
    fetch(resource, createResourceHeaders())
      .then( result => {
        if(!result.ok) {
          throw Error(result.statusText);
        }

        return result[format]()
      })
  )
};

export const createResourceHeaders = () => ({});


// WEBPACK FOOTER //
// ./src/Services/Misc/network.js